export const  BASE_URL:string ="https://api.foodmood.com.np/foodmoodlive";
export const BASE_HOME= "https://payment-foodmood.web.app"
//https://env-2770449.ktm.yetiappcloud.com
//https://api.foodmood.com.np/foodmoodlive
//https://payment-foodmood.web.app